import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-match-case',
  templateUrl: './pdf-find-match-case.component.html',
  styleUrls: ['./pdf-find-match-case.component.css'],
})
export class PdfFindMatchCaseComponent {}
